import { inject, Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { Store } from '@lib.core/store/store.service';

@Injectable({providedIn: 'root'})
export class ClientIdStorageService {
  private readonly store = inject(Store);
  private readonly key = 'clientId';


  setClientId(clientId: string | null): void {
    this.store.setValue(this.key, clientId);
  }
  
  getClientId(): Observable<string> {
    return this.store.getValue<string>(this.key).pipe(filter((clientId: string | null | undefined) => clientId !== null && clientId !== undefined));
  }
}